// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__jncae","layout--white-bg":"Layout_layout--white-bg__j7JvG","observer":"Layout_observer__09DIY"};